import React from "react";
import LegalLayout from "./LegalLayout";
import { SITE } from "../config/site";

export default function Terms() {
  return (
    <LegalLayout
      title="Terms"
      path="/terms"
      description="Terms for the Culmora OS pre-launch website."
    >
      <p>
        The Culmora OS website is a pre-launch informational website. By using
        this site you accept these terms.
      </p>
      <h2>Product status</h2>
      <p>
        Culmora OS is in pre-launch development. Features described on this site
        may change, and no service availability is guaranteed.
      </p>
      <h2>Early-access requests</h2>
      <p>
        Submitting the request form registers your interest. It does not create
        an account, guarantee access, or form a contract. Access, if offered,
        will be subject to separate product terms. No payment is collected
        through this website.
      </p>
      <h2>Acceptable use</h2>
      <p>
        Do not misuse the request form, attempt automated or fraudulent
        submissions, or interfere with the operation of this website.
      </p>
      <h2>Intellectual property</h2>
      <p>
        Culmora OS branding, product screenshots and original content remain
        protected. Unauthorised copying, impersonation or misuse is prohibited.
      </p>
      <h2>Liability</h2>
      <p>
        This website is provided as-is without warranties to the maximum extent
        permitted by applicable law.
      </p>
      <h2>Contact</h2>
      <p>
        For general enquiries, contact{" "}
        <a href={`mailto:${SITE.contactEmail}`} className="text-[hsl(var(--z-teal))]">
          {SITE.contactEmail}
        </a>
        .
      </p>
    </LegalLayout>
  );
}
